// extracted by mini-css-extract-plugin
export var cartItem = "_o-3";
export var drawerContent = "_o-0";
export var emptyCart = "_o-2";
export var fadeIn = "_o-4";
export var imagePlaceholder = "_o-6";
export var itemImage = "_o-5";
export var itemsContainer = "_o-1";